import { Component, Input } from '@angular/core';

// Badge assets per brand name as the validate endpoint / Worldpay SDK report them.
const BRAND_BADGES: { [brand: string]: { src: string, alt: string } } = {
  visa: { src: 'assets/img/payment-card/card-brand-visa.svg', alt: 'Visa' },
  mastercard: { src: 'assets/img/payment-card/card-brand-mastercard.svg', alt: 'Mastercard' }
};

/**
 * Presentational WorldPay card-field layout. Renders the empty hosted-field containers (with the exact
 * DOM ids the WorldpayProvider mounts into), labels, per-field error text and brand icon. Holds no SDK
 * or send-flow state — validity/brand are driven purely by @Inputs. 
 */
@Component({
  selector: 'rmt-worldpay-card-fields',
  templateUrl: 'rmt-worldpay-card-fields.html'
})
export class RmtWorldpayCardFieldsComponent {

  @Input() mode: 'card' | 'cvc' = 'card';
  @Input() containerId: string;
  @Input() fieldState: any = {};
  @Input() brandIcon: string = null;
  // Scheme brands from the validate endpoint's pspPaymentMethods (e.g. ['mastercard', 'visa']);
  // falls back to Mastercard+Visa when the BE sends none.
  @Input() brands: string[] = null;

  get brandBadges() {
    const codes = (this.brands && this.brands.length) ? this.brands : ['mastercard', 'visa'];
    return codes
      .map((code) => BRAND_BADGES[(code || '').toLowerCase()])
      .filter((badge) => !!badge);
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-worldpay-card-fields/rmt-worldpay-card-fields.ts